export const getSortByDateFilterMapping = {
  order_pickup_time: 'last_main_event_time',
};
